import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export type ButtonSize = 'small' | 'medium' | 'large';

const buttonSizes = {
	small: {
		fs: 14,
		lh: 18,
		py: 8,
		px: 20,
	},
	medium: {
		fs: 16,
		lh: 20,
		py: 10,
		px: 24,
	},
	large: {
		fs: 18,
		lh: 24,
		py: 12,
		px: 32,
	},
};

export const Text = styled.span<{ size: ButtonSize }>`
	font-family: var(--font);
	font-size: ${({ size = 'large' }) => `${buttonSizes[size].fs}px`};
	font-weight: 500;
	line-height: ${({ size = 'large' }) => `${buttonSizes[size].lh}px`};
	text-align: center;
	flex-shrink: 0;
`;

export const Button = styled.button<{
	width?: number;
	fullWidth?: boolean;
	shadowless?: boolean;
	size: ButtonSize;
}>`
	--bg: var(--color-white);
	--color: var(--color-black);

	${hoverable};

	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	row-gap: 14px;
	column-gap: 8px;
	flex-shrink: 0;
	width: ${({ width, fullWidth }) =>
		width ? `${width}px` : fullWidth ? '100%' : 'auto'};
	padding: ${({ size = 'large' }) =>
		`${buttonSizes[size].py}px ${buttonSizes[size].px}px`};
	color: var(--color);
	background-color: var(--bg);
	border: none;
	border-radius: 50px;
	transition: color 0.15s, background-color 0.15s, backdrop-filter 0.15s,
		box-shadow 0.15s;

	&[disabled],
	&.loading {
		pointer-events: none;
	}

	&.shadowless,
	&:hover.shadowless {
		box-shadow: none;
	}
`;

export const IconWrapper = styled.div<{ size: ButtonSize }>`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${({ size = 'large' }) => `${buttonSizes[size].lh}px`};
	height: ${({ size = 'large' }) => `${buttonSizes[size].lh}px`};

	& > svg {
		position: absolute;
	}
`;
